// src/context/PedidosContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { Api_VariavelGlobal } from '../global';

const PedidosContext = createContext();

export const usePedidos = () => useContext(PedidosContext);

export const PedidosProvider = ({ children }) => {
  const [novosPedidosCount, setNovosPedidosCount] = useState(0);

  const fetchPedidosNovos = async () => {
    try {
      const response = await fetch(`${Api_VariavelGlobal}/api/pedido/status/3`);
      if (!response.ok) {
        setNovosPedidosCount(0);
        return;
      }
      const data = await response.json();
      setNovosPedidosCount(Array.isArray(data) ? data.length : 0);
    } catch (error) {
      setNovosPedidosCount(0);
    }
  };

  useEffect(() => {
    fetchPedidosNovos();
    const interval = setInterval(fetchPedidosNovos, 2000); // atualiza a cada 2s
    return () => clearInterval(interval);
  }, []);

  return (
    <PedidosContext.Provider value={{ novosPedidosCount }}>
      {children}
    </PedidosContext.Provider>
  );
};
